import HammerAndWrench from 'assets/icons/hammerAndWrench.svg'

export default HammerAndWrench
